module.exports = __webpack_public_path__ + "static/17-02d54f31d7453bcd7efdcde1079205dc.jpg";